module.exports = __webpack_public_path__ + "img/ic_search_1.9f4f80a6.svg";